interface TimeCellProps {
  value: unknown;
}

export function TimeCell({ value }: TimeCellProps) {
  if (value == null || value === '') return null;
  return <span>{String(value)}</span>;
}
